// @flow

import { clientAddressServiceActions } from './clientAddressActionCreator';

const initialState = {
  fetching: null,
  fetched: null,
  clientAddressList: null,
  error: null,
  loading: null,
  loaded: null,
  address: null,
  previousAddressList: []
};

const clientAddressReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case clientAddressServiceActions.GET_PREVIOUS_CLIENT_ADDRESSES:
    case clientAddressServiceActions.FETCH_CLIENT_ADDRESSES:
    case clientAddressServiceActions.ADD_UPDATE_CLIENT_ADDRESS: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default clientAddressReducer;
